module.exports = __webpack_public_path__ + "img/IMG_20231123_162737_069-2.951dc8b4.jpg";